// extracted by mini-css-extract-plugin
export default {"favorite-cities-wrapper":"FavoriteCities_favorite-cities-wrapper__WTkoA","no-favorite-cities":"FavoriteCities_no-favorite-cities__f6nY2"};